import React, { useLayoutEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { getBattlebotSlotCenterPixels } from '../components/BattlebotPortalOverlay';
import './HiveSurgePulseEffect.css';

/**
 * Three glowing green upward chevrons on the target unit slot (shrinking animation).
 */
export function HiveSurgePulseEffect({ viewerSlot, animationKey }) {
  const [center, setCenter] = useState(null);

  useLayoutEffect(() => {
    let cancelled = false;
    const measure = (attempt) => {
      if (!viewerSlot?.zone || viewerSlot.index == null) {
        if (!cancelled) setCenter(null);
        return;
      }
      const pt = getBattlebotSlotCenterPixels(viewerSlot.zone, viewerSlot.index);
      if (pt) {
        if (!cancelled) setCenter(pt);
        return;
      }
      if (attempt < 18 && !cancelled) {
        requestAnimationFrame(() => {
          if (!cancelled) measure(attempt + 1);
        });
      }
    };
    setCenter(null);
    measure(0);
    return () => {
      cancelled = true;
    };
  }, [viewerSlot, animationKey]);

  if (!center) {
    return null;
  }

  const layer = (
    <div
      className="hive-surge-pulse-root"
      aria-hidden
      data-animation-key={animationKey}
      style={{
        left: `${center.x}px`,
        top: `${center.y}px`,
        transform: 'translate(-50%, -42%)',
      }}
    >
      <div className="hive-surge-pulse-stack">
        <span className="hive-surge-pulse-chevron" />
        <span className="hive-surge-pulse-chevron" />
        <span className="hive-surge-pulse-chevron" />
      </div>
    </div>
  );

  if (typeof document !== 'undefined' && document.body) {
    return createPortal(layer, document.body);
  }
  return layer;
}

export default HiveSurgePulseEffect;
